import React, { FC } from 'react';
import { StatusToast } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import StatusToastNotification from '@components/StatusToastNotification';

type ReportTemplateErrorNotificationProps = {
  showReportTemplateError: boolean;
  onSubmit: () => void;
  setShowReportTemplateError: (show: boolean) => void;
};

const ReportTemplateErrorNotification: FC<
  ReportTemplateErrorNotificationProps
> = ({ showReportTemplateError, onSubmit, setShowReportTemplateError }) => {
  const { t } = useTranslation();

  return (
    <StatusToastNotification
      show={showReportTemplateError}
      key="brief-page-error-message"
      status="error"
      dismissible
      duration={8000}
      dataHook="brief-page-error-message"
      onDismiss={() => setShowReportTemplateError(false)}
      action={
        <StatusToast.Action onClick={async () => await onSubmit()}>
          {t('marketplace.template-page.report-template-error-try-again-cta')}
        </StatusToast.Action>
      }
      message={t('marketplace.template-page.report-template-error')}
    />
  );
};

export default ReportTemplateErrorNotification;
